// extracted by mini-css-extract-plugin
module.exports = {"paginator":"Paginator_paginator__38Y0u"};